import { searchFromQuery, searchQuery, searchSnapshot, assertValidSearch } from './propertySearchFilters';

// Keep site-specific request options while applying the shared filter contract.
export function applyManualSearchFilters(query, edits = {}, shared = null) {
  if (shared && Object.keys(shared).length) {
    for (const key of Object.keys(searchFromQuery(query))) query.delete(key);
    searchQuery(shared).forEach((value, key) => query.append(key, value));
  }
  for (const key of Object.keys(edits)) query.delete(key);
  searchQuery(searchSnapshot(edits)).forEach((value, key) => query.append(key, value));
  assertValidSearch(searchFromQuery(query));
  return query;
}
